// ─── Auth token bridge ─────────────────────────────────────────────────────
// The data layer (hooks/useDB.js) needs the signed-in user's Firebase ID token
// so it can authenticate requests to the backend API (api/server.js). Firebase
// itself is initialized in App.js, so App.js registers a token provider here and
// the data layer consumes it. This keeps useDB.js free of any Firebase imports.

let _provider = null;

// Register a function that returns the current user's ID token (or null).
export function setTokenProvider(fn) {
  _provider = fn;
}

// Resolve the current Firebase ID token, or null if not signed in / unavailable.
export async function getIdToken() {
  if (!_provider) return null;
  try {
    return await _provider();
  } catch {
    return null;
  }
}
